import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FormBuilderModule } from '../form-builder/form-builder.module';
import { BrowserModule } from '@angular/platform-browser';
import { SdkCustomDialogComponent } from './sdk-custom-dialog.component';
import { SharedModule } from 'app/shared/shared.module';
@NgModule({
    declarations: [
        SdkCustomDialogComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        MatDialogModule,
        FormBuilderModule,
        SharedModule
    ],
    exports: [],
})
export class SDKCustomDialogModule{
    constructor(){}
}